// LoadingDots.js
import React from 'react';
import '../../App.css'; // Ensure you create this CSS file

const LoadingDots = () => {
    return (
        <div className="loading-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
        </div>
    );
};

export default LoadingDots;
